import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import AuthShell from "../components/AuthShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [resetLink, setResetLink] = useState(null);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.reset_link) setResetLink(data.reset_link);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Recuperar senha"
      subtitle="Informe seu e-mail para receber o link de redefinição."
      footer={
        <Link to="/login" className="text-emerald-400 hover:text-emerald-300 font-medium" data-testid="link-voltar-login">
          Voltar para o login
        </Link>
      }
    >
      {sent ? (
        <div className="text-center space-y-4" data-testid="forgot-success">
          <MailCheck className="w-12 h-12 text-emerald-400 mx-auto" />
          <p className="text-sm text-slate-300">Se o e-mail existir na plataforma, enviaremos o link de redefinição.</p>
          {resetLink && process.env.REACT_APP_SHOW_DEMO_CREDENTIALS === "true" && (
            <div className="bg-slate-800/50 border border-slate-700/60 rounded-lg p-3.5 text-xs text-slate-400 space-y-2">
              <p className="font-semibold text-slate-300">Modo demonstração (sem envio de e-mail):</p>
              <a href={resetLink} className="text-emerald-400 hover:text-emerald-300 break-all underline" data-testid="forgot-reset-link">
                {resetLink}
              </a>
            </div>
          )}
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-sm text-red-300" data-testid="forgot-error">
              {error}
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-slate-300">E-mail cadastrado</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@empresa.com.br"
              data-testid="forgot-email-input"
              className="bg-slate-800/60 border-slate-700 text-slate-100 placeholder:text-slate-500 focus-visible:ring-2 focus-visible:ring-emerald-500" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
            className="w-full bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold h-11 transition-colors duration-150">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar link de redefinição"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
